import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import {
  DropdownOptionComponent,
  DropdownOptionsBackdropComponent,
  TabOptionComponent,
  ColoredDropdownMenuButtonComponent,
  AddOptionComponent,
  ClearOptionComponent,
  VerticalTabOptionComponent,
} from './components/atoms';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { LoadersModule } from '@anecdotes/design-system/loaders';

@NgModule({
  declarations: [
    DropdownOptionsBackdropComponent,
    DropdownOptionComponent,
    TabOptionComponent,
    ColoredDropdownMenuButtonComponent,
    AddOptionComponent,
    ClearOptionComponent,
    VerticalTabOptionComponent,
  ],
  exports: [
    DropdownOptionComponent,
    DropdownOptionsBackdropComponent,
    TabOptionComponent,
    ColoredDropdownMenuButtonComponent,
    AddOptionComponent,
    ClearOptionComponent,
    VerticalTabOptionComponent,
  ],
  imports: [
    CommonModule,
    SvgIconsModule,
    TranslateModule,
    UtilsModule,
    NgbTooltipModule,
    DirectivesModule,
    LoadersModule,
  ],
})
export class DropdownAtomsModule {}
